import { element } from 'protractor';
import { NumberToTextService } from './../../services/utils/number-to-text.service';
import { BillingModel } from './../../models/medical-step-second.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal'

@Component({
  selector: 'app-simb-2545',
  templateUrl: './simb-2545.component.html',
  styleUrls: ['./simb-2545.component.scss']
})
export class Simb2545Component implements OnInit {

  discount: number;
  total: number;

  @Input('listOfData') listOfData: BillingModel[];
  @Input('isVisible') isVisible: Boolean;
  @Input('isSpinning') isSpinning: Boolean;
  @Input('haveBill') haveBill: Boolean;
  @Output() closeModal = new EventEmitter();
  @Output() setNewData = new EventEmitter();

  constructor(private numberToTextService: NumberToTextService, private modal: NzModalService) { }

  ngOnInit() {

  }

  widthWindow(): number {
    if (window.innerWidth <= 800) {
      return 600;
    } else if (window.innerWidth <= 1024) {
      return 800;
    } else {
      return 1000;
    }
  }

  screenWidth() {
    var table = document.getElementById("basicTable");
    if (table != null) {
      let tableSize = {
        x: table.offsetWidth.toString() + 'px',
        y: table.offsetHeight.toString() + 'px'
      }
      return tableSize;
    } else {
      let tableSize = {
        x: '600px',
        y: '800px'
      }
      return tableSize;
    }
  }

  close(passValue: boolean): void {
    let have91:boolean = false;
    let haveOther:boolean = false; 
 
    console.log('expense', this.listOfData);
    this.listOfData.forEach(item => {
      
      if (item.healCode == "9.1" && item.afterDiscount != "" && item.afterDiscount != "0" && item.afterDiscount != 0)
      {
        have91 = true;
      } else if (item.healCode != "2.6" && item.afterDiscount != "" && item.afterDiscount != "0"  && item.afterDiscount != 0) {
        haveOther = true;
      }
      if (item.expense == "") {
        item.expense = "0.00"
      }
     
    })

    if (have91 && haveOther)
    {
      this.modal.warning({
        nzTitle: 'กรณีป้อนค่าใช้จ่ายหมวด 9.1 สำหรับรองรับค่าใช้จ่ายรวม Billing ใหม่เท่านั้น จะไม่สามารถป้อนหมวดรายการอื่นได้',
        nzContent: ''
      });
    } else {
    
    if (passValue) {
      let data = {
        listData: this.listOfData,
        isSubmit: passValue,
        billType: 'o'
      }
      this.setNewData.emit(data);
    } else {
      this.closeModalandNotSave()
      let data = {
        listData: this.listOfData,
        isSubmit: passValue,
        billType: 'o'
      }
      this.setNewData.emit(data);
    }
    this.closeModal.emit(false);
  }
  }

  ngOnChanges(): void {
    // console.log('ngOnChanges');
    // console.log('haveBill', this.haveBill);
    if (this.isVisible == true) {
      this.listOfData.forEach(element => {
        let newExpense = element.expense
        if (typeof element.expense == 'string') {
          if (element.expense == "") {
            newExpense = "0.00"
          } else {
            newExpense = element.expense.replace(",", "");
          }
        }
        if (this.haveBill)
        {

        } else {
          this.discount = (this.stringToNumber(newExpense) * this.stringToNumber(element.discount)) / 100;
          this.total = this.stringToNumber(newExpense) - this.discount;
          element.afterDiscount = this.total;
        }
      })
    }
  }

  closeModalandNotSave(): void {
    let listData = sessionStorage.getItem('tempSimp2545');
    this.listOfData = JSON.parse(listData);
    this.listOfData.forEach(element => {
      let newExpense = element.expense
      if (typeof element.expense == 'string') {
        if (element.expense == "") {
          newExpense = "0.00"
        } else {
          newExpense = element.expense.replace(",", "");
        }
      }
      this.discount = (this.stringToNumber(newExpense) * this.stringToNumber(element.discount)) / 100;
      this.total = this.stringToNumber(newExpense) - this.discount;
      element.afterDiscount = this.total;
    })
  }

  resetValue(): void {
    this.haveBill = false;
    this.listOfData.forEach(element => {
      element.expense = ""
      element.afterDiscount = 0.00
    })
  }

  keyCurrency(event: any, index: number, discount: any): void {
    
    if (event.target.value == '') {
      // console.log('keyCurrency if');
      this.listOfData[index].expense = '';
      this.listOfData[index].afterDiscount = 0.00;
    } else {
      // console.log('keyCurrency else');
      let newExpense = event.target.value.replace(",", "");
      let value = this.stringToNumber(newExpense);
      if (!isNaN(value)) {
        // console.log('not nan');
        if (this.haveBill)
        {
        //   this.listOfData[index].expense = this.listOfData[index].afterDiscount;
             this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].afterDiscount);
        } else {
          let newExpense = event.target.value.replace(",", "");
          let value = this.stringToNumber(newExpense);
          this.discount = (value * this.stringToNumber(discount)) / 100;
          this.total = (value - this.discount);
          // console.log('discount = '+this.discount+' total = '+this.total);
          this.listOfData[index].afterDiscount = this.total;
         
        }
      } else {
        // console.log('nan');
        this.listOfData[index].expense = '';
        this.listOfData[index].afterDiscount = 0.00;
      }
    }
  }

  checkDiscount(event: any, index: number): void {
    // console.log('checkDiscount ',event.target.value);
    if (this.haveBill)
    {
      this.listOfData[index].afterDiscount = event.target.value;
      //this.listOfData[index].afterDiscount = event.target.value;
      //this.listOfData[index].afterDiscount = parseFloat(event.target.value);
      return;
    }
    if (event.target.value == '') {
      // console.log('checkDiscount if');
      this.listOfData[index].afterDiscount = 0.00
    } else {
      // console.log('checkDiscount else');
      if (this.stringToNumber(this.listOfData[index].discount) > 0) {
        if (this.stringToNumber(event.target.value) > (this.stringToNumber(this.listOfData[index].expense) - 0.01)) {
          this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].expense) - 0.01;
        } else {
          this.listOfData[index].afterDiscount = event.target.value;
        }
      } else {
        if (this.stringToNumber(event.target.value) > this.stringToNumber(this.listOfData[index].expense)) {
          this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].expense);
        } else {
          this.listOfData[index].afterDiscount = event.target.value;
        }
      }
    }
  }

  stringToNumber(numberStr: string): number {
    // console.log('call string to number');
    return this.numberToTextService.checkNumber(numberStr);
  }

}
